import { StarIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

type Props = {
  stars: number;
  showLabel?: boolean;
};

export function HotelStars({ stars, showLabel = true }: Props) {
  const intl = useIntl();

  if (!stars) return null;

  return (
    <div className="flex items-center gap-2">
      <div className="flex" aria-hidden>
        {Array.from(Array(Number(stars))).map((_, index) => (
          <StarIcon
            key={index}
            size={13}
            color="var(--color-core-caution-400)"
            weight="fill"
          />
        ))}
      </div>
      {showLabel && (
        <span className="text-sm text-text-primary">
          {intl.formatMessage(
            {
              defaultMessage: "{stars}-star hotel",
              description: "Hotel star rating label",
            },
            { stars },
          )}
        </span>
      )}
    </div>
  );
}
